import {booleanAttribute, Component, inject, input, output} from '@angular/core';
import {IconComponent} from '../icon/icon.component';
import {RouterLink} from '@angular/router';
import {IconType} from '../../icons';

interface ButtonStyle {
  readonly icon: IconType,
  readonly label: string,
  readonly style: 'success' | 'danger' | 'primary' | 'secondary'
}

const BUTTON_TYPES = Object.freeze({
  cancel: {icon: 'cancel', label: 'Cancel', style: 'danger'},
  delete: {icon: 'delete', label: 'Delete', style: 'danger'},
  copy: {icon: 'copy', label: 'Copy to Clipboard', style: 'secondary'},
  download: {icon: 'download', label: 'Download', style: 'primary'},
  manage: {icon: 'settings', label: 'Manage', style: 'primary'},
  new: {icon: 'new', label: 'New', style: 'primary'},
  new_pack: {icon: 'new_pack', label: 'New Pack', style: 'success'},
  new_prompt: {icon: 'new_prompt', label: 'New Prompt', style: 'success'},
  no: {icon: 'no', label: 'No', style: 'danger'},
  primary: {icon: 'unknown', label: 'NO LABEL', style: 'primary'},
  save: {icon: 'save', label: 'Save', style: 'success'},
  secondary: {icon: 'unknown', label: 'NO LABEL', style: 'secondary'},
  show_all: {icon: 'show_all', label: 'Show All', style: 'primary'},
  yes: {icon: 'yes', label: 'Yes', style: 'success'}
}) satisfies Record<string, ButtonStyle>

type ButtonType = keyof typeof BUTTON_TYPES;

@Component({
  selector: 'app-button',
  imports: [
    IconComponent
  ],
  templateUrl: 'button.component.html',
  host: {
    class: 'app-container'
  }
})
export class ButtonComponent {
  readonly type = input.required<ButtonStyle, ButtonType>({ transform: val => BUTTON_TYPES[val] })
  readonly label = input<string | null>(null)
  readonly description = input<string | null>(null)
  readonly icon = input<IconType | null>(null)
  readonly buttonStyle = input<ButtonStyle['style'] | null>(null)
  readonly disabled = input<boolean, any>(false, { transform: booleanAttribute })
  readonly transparent = input<boolean, any>(false, { transform: booleanAttribute })
  readonly clicked = output()

  private readonly routerLink = inject(RouterLink, { optional: true })

  protected onClick($event: MouseEvent) {
    if (!this.routerLink) this.clicked.emit()
    $event.preventDefault()
  }
}
